<template>
  <div :class="'intvSpecialTimeCale intvSpecialTimeCale' + uniqueId">
    <div class="cale_nav">
      <div></div>
      <div class="color_desc">
        <div class="can_intv">
          <span class="can_colorBlock"></span><span>可选择时间</span>
        </div>
        <div class="selected_intv"><span
            class="selected_colorBlock"></span><span>{{ getLangMsg("setIntvTime_key002") }}</span></div>
        <div class="cannot_intv">
          <span class="cannot_colorBlock"></span><span>{{ getLangMsg("setIntvTime_key003") }}</span>
          <el-popover
              placement="top-start"
              width="393"
              trigger="hover"
          >
            <div style="font-size: 12px;color: #212121">
              <div>每个时间刻度为面试时长+面试间隔，选中显示每个场次的面试时间；</div>
              <div>当刻度不足面试时长时，为不可选择的时间。</div>
            </div>
            <span slot="reference" class="kdfont kdfont-tishixinxi"
                  style="color: rgb(187, 187, 187);padding-left: 3px"></span>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="cale_content">
      <div class="cale_content_body">
        <div class="date_title">
          <div class="blank_space"></div>
          <div class="date_title_items">
            <div class="title_item" v-for="(item,index) in dayDateList">
              {{ dateFormat('MM月dd日', item) }}
            </div>
          </div>
        </div>
        <div class="date_body">
          <div class="scroll_content">
            <div class="date_body_scale">
              <div class="scale_item" :style="{'height':tableOneMinHeight * item.timeLong + 'px'}"
                   v-for="(item,index) in timeSpotList">
                {{ item.timeLong === (cusParam_specialIntvTimeData.preDurationTime + cusParam_specialIntvTimeData.preIntervalTime) ? dateFormat('hh:mm', item.timeNum) : '' }}
              </div>
            </div>
            <div class="date_body_content" :style="{'cursor':cusParam_specialCanOp ? 'pointer':'not-allowed'}"
                 @mousedown.stop.prevent="mousedownBody" @mouseup.stop="closeHoverState">
              <div class="day_list" v-for="(itemC,indexC) in dayDateList">
                <div class="hours_list" v-for="(itemR,indexR) in timeSpotList"
                     :style="{'height':tableOneMinHeight * itemR.timeLong + 'px'}"
                     :class="{'ishover':judgeIsHover(indexC,indexR),'isunable':judgeIsUnable(indexC,indexR),'isable':judgeIsAble(indexC,indexR)}"
                     @mouseenter.stop.prevent="mouseenterNode(indexC,indexR)"
                     @mousedown="mousedownNode(indexC,indexR)"
                     draggable="false" data_type="default">
                  <div class="scene_info" v-if="siteCountData[indexC+'-'+indexR]">
                    <span class="scene_count">{{
                        siteCountData[indexC + '-' + indexR]
                      }}</span>{{ calcTimeRange(indexR) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    cusParam_specialIntvTimeData: Object,
    cusParam_specialCanOp: Boolean,
    cusParam_isAutoSave: Boolean,
    cusParam_save: Number,
    cusParam_updateDateRange: Array,
    themeNum: String,
    lang: String
  },
  computed: {},
  watch: {
    cusParam_specialIntvTimeData: function (obj) {
      console.log(obj)
      this.dayDateList = obj.specialDateRange;
      this.timeSpotList = this.initCaleStructure(obj);
      this.unableSelectObj = {};
      for (let column = 0, clen = this.dayDateList.length; column < clen; column++) {
        this.selectedArr[column] = [];
        for (let row = 0, rlen = this.timeSpotList.length; row < rlen; row++) {
          this.selectedArr[column][row] = false;
          if (this.timeSpotList[row].timeLong !== (obj.preDurationTime + obj.preIntervalTime)) {
            this.unableSelectObj[column + '-' + row] = true;
          }
        }
      }
      // 计算一分钟时长占用的实际高度
      if ((obj.preDurationTime + obj.preIntervalTime) < 30) {
        this.tableOneMinHeight = 30 / (obj.preDurationTime + obj.preIntervalTime);
      } else if ((obj.preDurationTime + obj.preIntervalTime) > 60) {
        this.tableOneMinHeight = 60 / (obj.preDurationTime + obj.preIntervalTime);
      } else {
        this.tableOneMinHeight = 1
      }
      // 处理已选时间到二维矩阵中
      if (obj.planTimeList) {
        for (let index in obj.planTimeList) {
          let cIndex = this.dayDateList.indexOf(obj.planTimeList[index].dayDate);
          let rIndex = this.timeSpot_HHMM_Arr.indexOf(this.dateFormat('hh:mm', obj.planTimeList[index].startTime));
          this.selectedArr[cIndex][rIndex] = true;
          if(obj.planTimeList[index].candFlag === '1'){
            this.unableSelectObj[cIndex + '-' + rIndex] = true;
          }
        }
      }
      // 计算已选时间的顺序，记录下来用作展示
      this.siteCountData = this.assembleSiteCount(this.selectedArr);
      // 滚动到上午开始时间的点位处
      let amStartTimeNum = new Date('2000/1/1 ' + obj.preAmStartTimeHour + ':' + obj.preAmStartTimeMin + ':00').getTime();
      let amStartIndex = this.timeSpot_HHMM_Arr.indexOf(this.dateFormat('hh:mm', amStartTimeNum))
      let scrollHeight = this.timeSpotList[amStartIndex - 1].timeHeight + amStartIndex;
      this.$nextTick(() => {
        $(`.intvSpecialTimeCale${this.uniqueId} .scroll_content`).scrollTop(scrollHeight);
      })
    },
    cusParam_save: function (num) {
      this.submitResult();
    },
    cusParam_updateDateRange: function (timeRange) {
      if (timeRange !== null && timeRange.length > 0) {
        let newSelectArr = [];
        for (let index = 0, len = timeRange.length; index < len; index++) {
          if (this.dayDateList.includes(timeRange[index])) {
            newSelectArr.push(this.selectedArr[this.dayDateList.indexOf(timeRange[index])]);
          } else {
            newSelectArr.push([]);
          }
        }
        this.selectedArr = newSelectArr;
        this.siteCountData = this.assembleSiteCount(this.selectedArr);
        this.dayDateList = timeRange;
      }
    }
  },
  filters: {},
  data() {
    return {
      uniqueId: '',
      dayDateList: [1619884800000, 1619971200000],
      timeSpotList: [],
      timeSpot_HHMM_Arr: [],
      tableOneMinHeight: 1,
      ishoverState: false,
      startMoveSpot: [0, 0],//选择时间时的开始时间点
      endMoveSpot: [0, 0],//选择时间时的结束时间点
      selectedArr: [],
      unableSelectObj: {},
      siteCountData: {},
      scrollTimer: null,
      scrollSpeed: 0,
      timer: null
    }
  },
  mounted() {
    this.uniqueId = new Date().getTime();
    this.$nextTick(() => {
      this.hideScrollBar();
    })


  },
  methods: {
    initCaleStructure(caleConfig) {
      //以2000-1-1为示例计算日期
      let minTimeNum = new Date('2000/1/1 00:00:00').getTime();
      let maxTimeNum = new Date('2000/1/2 00:00:00').getTime();
      let amStartTimeNum = new Date('2000/1/1 ' + caleConfig.preAmStartTimeHour + ':' + caleConfig.preAmStartTimeMin + ':00').getTime();
      let pmStartTimeNum = new Date('2000/1/1 ' + caleConfig.prePmStartTimeHour + ':' + caleConfig.prePmStartTimeMin + ':00').getTime();
      let singleIntvTimeNum = caleConfig.preDurationTime * 60 * 1000;
      let intvTimeIntervalNum = caleConfig.preIntervalTime * 60 * 1000;
      let timeSpotArr = [minTimeNum, maxTimeNum, amStartTimeNum, pmStartTimeNum];
      let motorTime = amStartTimeNum;
      do {
        timeSpotArr.push(motorTime);
        motorTime -= (singleIntvTimeNum + intvTimeIntervalNum);
      } while (motorTime > minTimeNum)
      motorTime = amStartTimeNum;
      do {
        timeSpotArr.push(motorTime);
        motorTime += (singleIntvTimeNum + intvTimeIntervalNum);
      } while (motorTime < pmStartTimeNum)
      motorTime = pmStartTimeNum;
      do {
        timeSpotArr.push(motorTime);
        motorTime += (singleIntvTimeNum + intvTimeIntervalNum);
      } while (motorTime < maxTimeNum)
      timeSpotArr = [...new Set(timeSpotArr)].sort();
      let newTimeSpotArr = []; //记录点位完整信息
      this.timeSpot_HHMM_Arr = []; //记录点位的hh:mm格式，方便后面接收数据
      let timeCumHeight = 0; //记录点位在选择器中的绝对高度
      for (let spotIndex = 0, len = timeSpotArr.length; spotIndex < len - 1; spotIndex++) {
        let timeLong = (timeSpotArr[spotIndex + 1] - timeSpotArr[spotIndex]) / (1000 * 60);
        timeCumHeight += timeLong;
        newTimeSpotArr.push({
          timeNum: timeSpotArr[spotIndex],
          timeLong: timeLong,
          timeHeight: timeCumHeight
        })
        this.timeSpot_HHMM_Arr.push(this.dateFormat('hh:mm', timeSpotArr[spotIndex]));
      }
      console.log(newTimeSpotArr)
      return newTimeSpotArr;
    },
    judgeIsHover(column, row) {
      if (!this.ishoverState) {
        return false
      }
      let minX = Math.min(this.startMoveSpot[0], this.endMoveSpot[0]);
      let maxX = Math.max(this.startMoveSpot[0], this.endMoveSpot[0]);
      let minY = Math.min(this.startMoveSpot[1], this.endMoveSpot[1]);
      let maxY = Math.max(this.startMoveSpot[1], this.endMoveSpot[1]);
      if ((column <= maxX && column >= minX) && (row <= maxY && row >= minY)) return true;
      return false;
    },
    judgeIsUnable(column, row) {
      return this.unableSelectObj[column + '-' + row];
    },
    judgeIsAble(column, row) {
      return this.selectedArr && this.selectedArr[column] && this.selectedArr[column][row];
    },
    mousedownBody() {
      if (!this.cusParam_specialCanOp) {
        return
      }
      this.ishoverState = true;
      //注册外部抬起鼠标按钮及鼠标超出时间选择窗口的行为事件
      let _this = this;
      document.addEventListener('mouseup', _this.closeHoverState);
      document.addEventListener('mousemove', _this.mousemoveBody);
    },
    closeHoverState() {
      if (this.ishoverState) {
        //将选择转态设置为false
        this.ishoverState = false;
        //清除鼠标超出时间选择窗口时的轮询滚动定时器
        clearInterval(this.scrollTimer);
        //解绑外部抬起鼠标按钮及鼠标超出时间选择窗口的行为事件
        let _this = this;
        document.removeEventListener('mouseup', _this.closeHoverState);
        document.removeEventListener('mousemove', _this.mousemoveBody);
        //统计选择状态
        let minX = Math.min(this.startMoveSpot[0], this.endMoveSpot[0]);
        let maxX = Math.max(this.startMoveSpot[0], this.endMoveSpot[0]);
        let minY = Math.min(this.startMoveSpot[1], this.endMoveSpot[1]);
        let maxY = Math.max(this.startMoveSpot[1], this.endMoveSpot[1]);
        for (let column = minX; column <= maxX; column++) {
          for (let row = minY; row <= maxY; row++) {
            if (!this.unableSelectObj[column + '-' + row]) {
              this.selectedArr[column][row] = !this.selectedArr[column][row]
            }
          }
        }
        this.siteCountData = this.assembleSiteCount(this.selectedArr);
        if (this.cusParam_isAutoSave) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.submitResult();
          }, 3000)
        }
      }
    },
    assembleSiteCount(selectedSiteArr) {
      let siteData = {};
      this.selectedArr.map((cValue, cIndex) => {
        let count = 1;                              //场次index
        cValue.map((rValue, rIndex) => {
          if (rValue) {
            siteData[cIndex + '-' + rIndex] = count++
          }
        })
      })
      return siteData;
    },
    mouseenterNode(column, row) {
      if (!this.ishoverState) {
        return;
      }
      this.endMoveSpot = [column, row];
    },
    mousedownNode(column, row) {
      this.startMoveSpot = this.endMoveSpot = [column, row];
    },
    mousemoveBody(e) {
      if (this.ishoverState) {
        let body_startY = $(`.intvSpecialTimeCale${this.uniqueId} .date_body`)[0].getBoundingClientRect().y;
        let body_endY = body_startY + $(`.intvSpecialTimeCale${this.uniqueId} .date_body`).height();
        let _this = this;
        if (e.clientY > (body_endY + 5)) {
          this.scrollSpeed = e.clientY - body_endY;
          if (!this.scrollTimer) {
            this.scrollTimer = setInterval(() => {
              let el = $(`.intvSpecialTimeCale${this.uniqueId} .scroll_content`);
              el.scrollTop(el.scrollTop() + _this.scrollSpeed)
            }, 100)
          }
        } else if (e.clientY < (body_startY - 5)) {
          this.scrollSpeed = e.clientY - body_startY;
          if (!this.scrollTimer) {
            this.scrollTimer = setInterval(() => {
              let el = $(`.intvSpecialTimeCale${this.uniqueId} .scroll_content`);
              el.scrollTop(el.scrollTop() + _this.scrollSpeed)
            }, 100)
          }
        } else {
          if (this.scrollTimer) {
            clearInterval(this.scrollTimer);
            this.scrollTimer = null;
          }
        }
      }
    },
    calcTimeRange(index) {
      let timeNum = this.timeSpotList[index].timeNum;
      return this.dateFormat('hh:mm', timeNum) + ' ~ ' + this.dateFormat('hh:mm', timeNum + this.cusParam_specialIntvTimeData.preDurationTime * 60 * 1000);
    },
    hideScrollBar() {
      let el = $(`.intvSpecialTimeCale${this.uniqueId} .scroll_content`);
      let scrollWidth = el[0].offsetWidth - el[0].clientWidth;
      el.css("marginRight", "-" + scrollWidth + "px")
    },

    submitResult() {
      let selectTimes = [];
      for (let column = 0, clen = this.dayDateList.length; column < clen; column++) {
        for (let row = 0, rlen = this.timeSpotList.length; row < rlen; row++) {
          if (this.selectedArr[column][row]) {
            let startTimeStr = this.dateFormat('yyyy/MM/dd', this.dayDateList[column]) + ' ' + this.dateFormat('hh:mm', this.timeSpotList[row].timeNum);
            let timeOjb = {
              specialId: this.cusParam_specialIntvTimeData.specialId,
              startTime: new Date(startTimeStr).getTime(),
              endTime: new Date(new Date(startTimeStr).getTime() + this.cusParam_specialIntvTimeData.preDurationTime * 60 * 1000),
              dayDate: this.dayDateList[column]
            }
            selectTimes.push(timeOjb);
          }
        }
      }
      this.cusParam_specialIntvTimeData.specialDateRange = this.dayDateList;
      this.cusParam_specialIntvTimeData.planTimeList = selectTimes;
      this.invoke("form_specialIntvTimeData", this.cusParam_specialIntvTimeData);
    }
  }
}
</script>
<style lang="less">
.intvSpecialTimeCale {
  font-size: 12px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;

  .cale_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 0 16px;
    margin-bottom: 8px;

    .color_desc {
      color: #333333;
      display: flex;
      flex-direction: row;


      .cannot_intv, .can_intv, .selected_intv {
        display: flex;
        margin-left: 24px;
      }

      .selected_colorBlock {
        width: 16px;
        height: 16px;
        background: #DCFAE4;
        border-radius: 1px;
        margin-right: 8px;
      }

      .can_colorBlock {
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 1px;
        margin-right: 8px;
      }

      .cannot_colorBlock {
        width: 16px;
        height: 16px;
        background: #EAEAEA;
        border-radius: 1px;
        margin-right: 8px;
      }

    }
  }

  .cale_content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 1;

    .cale_content_body {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      flex-grow: 1;
      flex-shrink: 1;

      .date_title {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        height: 40px;
        flex-shrink: 0;

        .blank_space {
          width: 45px;
          text-align: end;
          padding-right: 13px;
          line-height: 48px;
          color: #999999;
        }

        .date_title_items {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;
          align-items: stretch;

          .title_item {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-grow: 1;
            flex-shrink: 1;
            background: #F5F5F5;
            color: #212121;
            font-weight: 600;
          }
        }
      }

      .date_body {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-grow: 1;
        flex-shrink: 1;
        height: 100px;
        overflow-x: hidden;

        .scroll_content {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;
          overflow-y: scroll;
          overflow-x: hidden;
          align-items: start;
        }

        .date_body_scale {
          width: 45px;
          display: flex;
          flex-direction: column;
          justify-content: start;
          align-items: stretch;

          .scale_item {
            flex-shrink: 0;
            height: 30px;
            margin-bottom: 1px;
            text-align: start;
            padding-right: 13px;
          }
        }

        .date_body_content {
          position: relative;
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;
          background: #E5E5E5;
          border-left: 1px solid #e5e5e5;
          border-bottom: 1px solid #e5e5e5;


          .day_list {
            width: 100px;
            position: relative;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            flex-shrink: 1;

            .hours_list {
              display: flex;
              flex-direction: row;
              align-items: stretch;
              flex-shrink: 0;
              height: 30px;
              //margin: 0 2px 2px 0;
              //background: #F8F8F8;
              margin: 0 1px 1px 0;
              background: #FFFFFF;

              .scene_info {
                flex-grow: 1;
                flex-shrink: 1;
                display: flex;
                align-items: center;
                border-left: 3px solid #1BA854;

                .scene_count {
                  font-weight: 700;
                  color: #1BA854;
                  margin: 0 10px;
                }
              }

            }

            .ishover {
              background: #DCFAE4;
            }

            .isunable {
              background: #EEEEEE !important; //暂不需要颜色区分，先留存
            }

            .isable {
              background: #DCFAE4;
            }
          }

        }
      }
    }
  }
}
</style>